/**
 * Connection Store for AccountsGenie
 * Manages Tally connection state and status following PRD specifications (lines 294-301)
 */

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { ConnectionState } from './types';
import { createConnectionActions } from './actions';
import { clearStaleConnectionData } from '../../utils/clearStaleData';

// Clear stale data BEFORE store creation to prevent hydration with old data
clearStaleConnectionData();

export const useConnectionStore = create<ConnectionState>()(
  persist(
    (set, get) => {
      // Create actions
      const actions = createConnectionActions(set, get);

      return {
        // Initial state
        status: 'not_connected',
        lastConnected: null,
        deviceName: null,
        tallyVersion: null,
        companyName: null,
        connectionId: null,
        companies: [],
        selectedCompany: null,
        lastChecked: null,
        consecutiveFailures: 0,
        isHealthy: false,
        isLoading: false,
        error: null,
        isInitialized: false,

        _healthMonitorInterval: null as ReturnType<typeof setInterval> | null,

        // Actions
        ...actions
      };
    },
    {
      name: 'connection-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        status: state.status,
        lastConnected: state.lastConnected,
        deviceName: state.deviceName,
        tallyVersion: state.tallyVersion,
        companyName: state.companyName,
        connectionId: state.connectionId,
        companies: state.companies,
        selectedCompany: state.selectedCompany,
        isInitialized: state.isInitialized,
      }),
      onRehydrateStorage: () => (state, error) => {
        if (error) {
          console.error('Error during hydration:', error);
        }
      },
    }
  )
);
